import { shallowEqual, useSelector } from 'react-redux';
import { userDeviceDetailsSelector } from '@hero/redux-data/backoffice/userDeviceDetails/selectors';
import { membershipDetailsSelector } from '@hero/redux-data/backoffice/membershipDetails/selectors';
import { useMemo } from 'react';
const useGetDetailViewTitle = () => {
    const userDetails = useSelector(userDeviceDetailsSelector, shallowEqual);
    const membership = useSelector(membershipDetailsSelector, shallowEqual);
    const userFullName = `${userDetails?.user?.first_name || ''} ${userDetails?.user?.last_name || ''}`.trim();
    const deviceSerials = useMemo(() => {
        const device = {
            serial: membership?.serial || userDetails?.device?.serial,
            external_serial: userDetails?.device?.external_serial
        };
        return `Device: ${device?.serial || '-'} / ${device?.external_serial || '-'}`;
    }, [membership, userDetails]);
    return userFullName ? `${userFullName} - ${deviceSerials}` : deviceSerials;
};
export default useGetDetailViewTitle;
